import { isFDR } from "@tvg/utils/generalUtils";
import useExperiments from "../../useExperiments";
import { DEPLOYMENT_KEY, EXPERIMENT_KEY } from "./constants";
import { VariantEnum, AutoPlayConfig } from "./types";
import { parseResponse } from "./utils";

export const useAutoPlayPPVideos = () => {
  // workaround to avoid "Reference error: localStorage is not defined" on TVG5
  if (!isFDR()) return parseResponse(undefined);
  const { getVariant } = useExperiments(DEPLOYMENT_KEY);

  const variant = getVariant<VariantEnum, number>(EXPERIMENT_KEY);

  return parseResponse(variant);
};

export { AutoPlayConfig };
